<div class="ai-chat-widget">
    <!-- Floating Widget Button -->
    <button *ngIf="!isExpanded" class="widget-button" (click)="toggleWidget()" aria-label="Open AI Assistant"
        title="Chat with AI Assistant">
        <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
            <path d="M8 10h.01M12 10h.01M16 10h.01"></path>
        </svg>
        <span class="pulse-ring" *ngIf="status === 'idle'"></span>
    </button>

    <!-- Expanded Widget Panel -->
    <div class="widget-panel" *ngIf="isExpanded" [class.minimized]="isMinimized">
        <!-- Widget Header -->
        <div class="widget-header">
            <div class="header-content">
                <div class="agent-info">
                    <div class="agent-avatar">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2">
                            <circle cx="12" cy="12" r="10"></circle>
                            <path d="M8 14s1.5 2 4 2 4-2 4-2M9 9h.01M15 9h.01"></path>
                        </svg>
                    </div>
                    <div class="agent-details">
                        <h3>AI Assistant</h3>
                        <p class="status-text" [class.connected]="status === 'connected'"
                            [class.error]="status === 'error'">
                            <span class="status-dot" [class.active]="status === 'connected'"></span>
                            {{ statusMessage }}
                            <!-- <span *ngIf="status === 'connected'" class="participant-badge">
                                {{ participantCount + 1 }} in room
                            </span> -->
                        </p>
                    </div>
                </div>
            </div>
            <div class="header-actions">
                <button class="icon-btn" (click)="minimize()" *ngIf="!isMinimized" title="Minimize"
                    aria-label="Minimize">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2">
                        <line x1="5" y1="12" x2="19" y2="12"></line>
                    </svg>
                </button>
                <button class="icon-btn" (click)="restore()" *ngIf="isMinimized" title="Restore" aria-label="Restore">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2">
                        <polyline points="15 3 21 3 21 9"></polyline>
                        <polyline points="9 21 3 21 3 15"></polyline>
                        <line x1="21" y1="3" x2="14" y2="10"></line>
                        <line x1="3" y1="21" x2="10" y2="14"></line>
                    </svg>
                </button>
                <button class="icon-btn close-btn" (click)="closeWidget()" title="Close" aria-label="Close">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2">
                        <line x1="18" y1="6" x2="6" y2="18"></line>
                        <line x1="6" y1="6" x2="18" y2="18"></line>
                    </svg>
                </button>
            </div>
        </div>

        <!-- Widget Body -->
        <div class="widget-body" *ngIf="!isMinimized">
            <!-- Loading State -->
            <div class="state-container" *ngIf="status === 'loading'">
                <div class="spinner"></div>
                <p>Loading AI agents...</p>
            </div>

            <!-- Error State -->
            <div class="state-container error-state" *ngIf="status === 'error'">
                <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2">
                    <circle cx="12" cy="12" r="10"></circle>
                    <line x1="12" y1="8" x2="12" y2="12"></line>
                    <line x1="12" y1="16" x2="12.01" y2="16"></line>
                </svg>
                <p class="error-message">{{ errorMessage }}</p>
            </div>

            <!-- Idle/Connected State -->
            <div class="chat-container" *ngIf="status !== 'loading' && status !== 'error'">
                <!-- Voice Chat Interface -->
                <div class="voice-interface">
                    <div class="voice-visualizer" [class.active]="status === 'connected'" [class.speaking]="isSpeaking">
                        <div class="wave-container">
                            <div class="wave" *ngIf="isSpeaking"></div>
                            <div class="wave wave-2" *ngIf="isSpeaking"></div>
                            <div class="wave wave-3" *ngIf="isSpeaking"></div>
                        </div>
                        <div class="mic-icon" *ngIf="!isSpeaking">
                            <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2">
                                <path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z"></path>
                                <path d="M19 10v2a7 7 0 0 1-14 0v-2"></path>
                                <line x1="12" y1="19" x2="12" y2="23"></line>
                                <line x1="8" y1="23" x2="16" y2="23"></line>
                            </svg>
                        </div>
                    </div>

                    <div class="voice-status">
                        <p *ngIf="status === 'idle'">Click "Start Conversation" to begin talking with the AI assistant
                        </p>
                        <p *ngIf="status === 'connecting'">Establishing connection...</p>
                        <p *ngIf="status === 'connected' && !isSpeaking">Listening... speak now</p>
                        <p *ngIf="status === 'connected' && isSpeaking">AI is responding...</p>
                    </div>
                </div>

                <!-- Instructions -->
                <div class="instructions" *ngIf="status === 'idle'">
                    <div class="instruction-item">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2">
                            <path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z"></path>
                            <path d="M19 10v2a7 7 0 0 1-14 0v-2"></path>
                        </svg>
                        <span>Microphone access required</span>
                    </div>
                    <div class="instruction-item">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2">
                            <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"></polyline>
                        </svg>
                        <span>Speak naturally and clearly</span>
                    </div>
                    <div class="instruction-item">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2">
                            <path d="M3 18v-6a9 9 0 0 1 18 0v6"></path>
                            <path
                                d="M21 19a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3zM3 19a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2H3z">
                            </path>
                        </svg>
                        <span>Listen for AI responses</span>
                    </div>
                </div>
            </div>
        </div>

        <!-- Widget Footer -->
        <div class="widget-footer" *ngIf="!isMinimized">
            <button *ngIf="canConnect()" class="action-btn connect-btn" (click)="connect()">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                    <polygon points="5 3 19 12 5 21 5 3"></polygon>
                </svg>
                Start Conversation
            </button>
            <button *ngIf="canDisconnect()" class="action-btn disconnect-btn" (click)="disconnect()">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                    <rect x="6" y="4" width="4" height="16"></rect>
                    <rect x="14" y="4" width="4" height="16"></rect>
                </svg>
                End Conversation
            </button>
            <div class="footer-info">
                <span>Powered by Indus Labs</span>
            </div>
        </div>
    </div>
</div>